<template>
  <ReportList v-bind="$props" />
</template>

<script>
import ReportList from '@/components/ReportList';

export default {
  name: 'ReportsTab',

  components: {
    ReportList,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    'distributor_id',
    'subdistributor_id',
    'chain_id',
    'store_id',
  ],
};
</script>
